define('util/propertyUtils',[
    'lib/knockout',
    'lib/lodash4',
    'services/loggingService',
    //no references required
    'extensions/i18n/knockout.i18n'
], function (ko, _, loggingService) {
    'use strict';

    var normalizeProperty =  function(propertyValue) {
        return _(propertyValue).toString().replace(/[\s\/]/g,'-').toLowerCase();
    };
    var createOptionsObject = function(namespace, propertyKey, options, propId, propName) {
        var propertyPath = namespace + '.'+ propertyKey;
        var stationInstanceBasePath = namespace.substring(0,namespace.lastIndexOf(".")) + '.' + propertyKey;

        return _.map(options, function(enumItem) {
            var retObj = {};
            var id = enumItem;
            var displayName = enumItem;
            var localizedEnum = propertyPath + '.'+ normalizeProperty(enumItem);
            var localizedStation = stationInstanceBasePath + '.'+ normalizeProperty(enumItem);
            if (ko.i18n.keyExists (localizedEnum)) {
                displayName = ko.i18n.renderString(localizedEnum);
            }
            else if (ko.i18n.keyExists (localizedStation)) {
                displayName = ko.i18n.renderString(localizedStation);
            }
            else if (ko.i18n.keyExists (stationInstanceBasePath)) {
                displayName = ko.i18n.renderString(stationInstanceBasePath);
            }
            else {
                loggingService.warn(localizedEnum + ' is an enum property that is not localized. Current value is: ' + enumItem);
            }
            if (propId && propName) {
                retObj[propId] = id;
                retObj[propName] = displayName;
            }
            else {
                retObj.id = id;
                retObj.name = displayName;
            }
            return retObj;
        });
    };
    var createOptionsValue = function(namespace, propertyKey, value, propId, propName) {

        return ko.computed({
            read: function () {
                var retObj = {};
                var val = ko.unwrap(value);
                var propVal;
                if (_.isPlainObject(val)) {
                    if (propId && propName) {
                        propVal = ko.unwrap(val[propId]);
                    }
                    else {
                        propVal = ko.unwrap(val.id);
                    }
                }
                else {
                    propVal = val;
                }
                var propertyPath = namespace + '.'+ propertyKey + '.'+ normalizeProperty(propVal);
                var localizedName = propVal;
                if (ko.i18n.keyExists (propertyPath)) {
                    localizedName = ko.i18n.renderString(propertyPath);
                }
                if (propId && propName) {
                    retObj[propId] = propVal;
                    retObj[propName] = localizedName;
                }
                else {
                    retObj.id = propVal;
                    retObj.name = localizedName;
                }
                return retObj;
            },
            write: function(newValue) {
                var id = 'id';

                if (propId && propName) {
                    id = propId;
                }
                var val = ko.unwrap(value);
                var propVal;
                if (_.isPlainObject(val)) {
                    propVal = ko.unwrap(val[id]);
                    if (newValue[id] !== propVal) {
                        value(newValue);
                    }
                }
                else {
                    if (newValue[id] !== val) {
                        value(newValue[id]);
                    }
                }
            }
        });

    };
    var propertyUtils = {
        normalizeProperty: normalizeProperty,
        createOptionsObject: createOptionsObject,
        createOptionsValue: createOptionsValue
    };

    return propertyUtils;
});

